import axios, { type AxiosError, type AxiosInstance } from "axios";
import { acquireApiToken, login } from "@/auth/msal";
import { config } from "@/lib/config";

let cached: AxiosInstance | null = null;

export function api(): AxiosInstance {
  if (cached) return cached;

  const instance = axios.create({
    baseURL: config.apiBase,
    headers: { "Content-Type": "application/json" },
    withCredentials: false,
    timeout: 30_000,
  });

  instance.interceptors.request.use(async (cfg) => {
    if (config.isAuthEnabled()) {
      const token = await acquireApiToken().catch(() => null);
      if (token) {
        cfg.headers = cfg.headers ?? {};
        cfg.headers.Authorization = `Bearer ${token}`;
      }
    }
    return cfg;
  });

  instance.interceptors.response.use(
    (r) => r,
    (err: AxiosError) => {
      if (err.response?.status === 401 && config.isAuthEnabled()) {
        login().catch(() => {});
        return new Promise(() => {});
      }
      return Promise.reject(err);
    },
  );

  cached = instance;
  return instance;
}
